if (!customElements.get("giftcard-switcher")) {
  customElements.define(
    "giftcard-switcher",
    class GiftcardSwitcher extends HTMLElement {
      abortController = undefined;

      get sectionId() {
        return this.getAttribute("data-section-id");
      }

      connectedCallback() {
        this.handleChange = this.handleChange.bind(this);
        this.handlePopState = this.handlePopState.bind(this);
        this.addEventListener("change", this.handleChange);
        window.addEventListener("popstate", this.handlePopState);
      }

      disconnectedCallback() {
        this.removeEventListener("change", this.handleChange);
        window.removeEventListener("popstate", this.handlePopState);
        this.abortController?.abort();
      }

      handleChange(event) {
        const input = event.target;
        if (input.type !== "radio") return;

        const productUrl = input.getAttribute("data-product-url");
        if (!productUrl || productUrl === window.location.pathname) return;

        const previousInput = this.querySelector("input:checked");
        const sectionEl = document.getElementById(
          `shopify-section-${this.sectionId}`
        );

        this.setLoading(sectionEl, true);

        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(
          `${productUrl}?section_id=${encodeURIComponent(this.sectionId)}`,
          { signal: this.abortController.signal }
        )
          .then((response) => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.text();
          })
          .then((responseText) => {
            const newSection = new DOMParser()
              .parseFromString(responseText, "text/html")
              .querySelector(".shopify-section");

            if (!newSection)
              throw new Error(
                `[GiftcardSwitcher] Section "${this.sectionId}" not found in response. Make sure both products use the same template.`
              );

            if (sectionEl) {
              sectionEl.innerHTML = newSection.innerHTML;
              this.setLoading(sectionEl, false);
            }

            history.pushState({}, "", productUrl);
          })
          .catch((error) => {
            if (error.name === "AbortError") return;
            console.error("[GiftcardSwitcher]", error);

            if (previousInput) previousInput.checked = true;
            this.setLoading(sectionEl, false);
          });
      }

      handlePopState() {
        const sectionEl = document.getElementById(
          `shopify-section-${this.sectionId}`
        );
        this.setLoading(sectionEl, true);

        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(
          `${window.location.pathname}?section_id=${encodeURIComponent(this.sectionId)}`,
          { signal: this.abortController.signal }
        )
          .then((response) => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.text();
          })
          .then((responseText) => {
            const newSection = new DOMParser()
              .parseFromString(responseText, "text/html")
              .querySelector(".shopify-section");

            if (!newSection) throw new Error("Section not found in response");

            if (sectionEl) {
              sectionEl.innerHTML = newSection.innerHTML;
              this.setLoading(sectionEl, false);
            }
          })
          .catch((error) => {
            if (error.name === "AbortError") return;
            console.error("[GiftcardSwitcher popstate]", error);
            this.setLoading(sectionEl, false);
          });
      }

      setLoading(sectionEl, isLoading) {
        if (!sectionEl) return;
        if (isLoading) {
          sectionEl.setAttribute("data-page-rendering", "");
          sectionEl.style.transition = "opacity 0.15s";
          sectionEl.style.opacity = "0.5";
          sectionEl.style.pointerEvents = "none";
        } else {
          sectionEl.removeAttribute("data-page-rendering");
          sectionEl.style.transition = "";
          sectionEl.style.opacity = "";
          sectionEl.style.pointerEvents = "";
        }
      }
    }
  );
}
